/**
 * A thrown value as an Error, for trackError, which takes an Error or a string.
 *
 * `catch (err)` hands over `unknown`; the hooks pasted
 * `err instanceof Error ? err : new Error(String(err))` into every handler.
 * One tested copy keeps them the same.
 */
export function asError(value: unknown): Error {
  return value instanceof Error ? value : new Error(String(value));
}
